export default __webpack_public_path__ + "static/media/tented.40c65288.png";